import { useMutation } from "@tanstack/react-query";
import {
  type AuthCreatePurchaseResponse,
  authCreatePurchase,
} from "../api/private/authCreatePurchase";
import { useToken } from "../contexts/TokenContext";

interface UseAuthCreatePurchaseOptions {
  onSuccess?: (data: AuthCreatePurchaseResponse) => void;
  onError?: (error: Error) => void;
}

type AuthCreatePurchaseVariables = void;

export const useAuthCreatePurchase = (options?: UseAuthCreatePurchaseOptions) => {
  const { idToken } = useToken();

  return useMutation<AuthCreatePurchaseResponse, Error, AuthCreatePurchaseVariables>({
    mutationFn: () => {
      if (!idToken) {
        throw new Error("No authentication token available");
      }
      return authCreatePurchase(idToken);
    },
    onSuccess: options?.onSuccess,
    onError: options?.onError,
    retry: false, // Don't retry authentication-related requests
  });
};
